const TYPE_KEY_DOWN = 'keydown'
const DIGIT = 'Digit'
const CODE_ENTER = 'Enter'

const pastCode = {
  data () {
    return {
      code: '',
      pastCodeList: []
    }
  },
  provide () {
    const pastCodeData = {}

    Object.defineProperty(pastCodeData, 'pastCodeList', {
      enumerable: true,
      get: () => this.pastCodeList
    })

    return {
      pastCodeData,
      clearPastCode: this.clearPastCode
    }
  },
  created () {
    document.addEventListener('keydown', this.pasteCode)
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.pasteCode)
  },
  methods: {
    pasteCode ({ type, code, key, target } = {}) {
      if (target?.tagName === 'INPUT') {
        return
      }

      if (type === TYPE_KEY_DOWN && code.startsWith(DIGIT)) {
        this.setCode(key)
      }

      if (code === CODE_ENTER) {
        this.pastCodeList.push(this.code)

        this.clearCode()
      }
    },
    setCode (code = '') {
      this.code += code
    },
    clearCode () {
      this.code = ''
    },
    clearPastCode () {
      this.pastCodeList = []
    }
  }
}

export default pastCode